module.exports = __webpack_public_path__ + "files/30c390658fe03b9cbd73ba66c61236ec.png";